export {
  Chip,
  type ChipProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Chip';
